import { AISVesselDto, EquipmentDetailsDto } from "~/api/GeneratedApi";
import { FleetItemInternal } from "./FleetItems";

export function generateFleetItemId(item: FleetItemInternal): string {
  const { type, data } = item;
  switch (type) {
    case "ais":
      return `ais-${(data as AISVesselDto).mmsi.toString()}`;
    case "equipment":
      return (data as EquipmentDetailsDto).id as unknown as string;
    default:
      return `-`;
  }
}
